module.exports = __webpack_public_path__ + "static/media/sand-clock.fba19c55.svg";